module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hant_1-de5670c319d25e8874fa2ea2c32b2cc0.jpg";